var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-sm",class:_vm.getButtonClasses(_vm.button),attrs:{"type":"button"},on:{"click":function($event){return _vm.setExpectedAnswerValueLocal(_vm.button.id)}}},[_vm._v(" "+_vm._s(_vm.button.answer)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }